import { BASKET_TYPES, selectBasketCheckPrice, selectBasketList } from 'containers/OrderDetails/basketSlice'
import { useReduxSelector } from 'store'

type BasketItem = basic.Form

const useShopItems = ({
  warehouseId,
  equipmentId,
  cartId,
}: {
  warehouseId?: string
  equipmentId?: string
  cartId?: string
}) => {
  const list = useReduxSelector(selectBasketList)
  const checkPrice = useReduxSelector(selectBasketCheckPrice)
  if (equipmentId && cartId) {
    return {
      equipment: list.find((item: BasketItem) => item.identifier === cartId)?.equipment as basic.Object<shop.EquipmentItem>,
      checkPrice: checkPrice?.[cartId]
    }
  }

  return {
    /** pozycje rent dodane ze sklepu (wynajem krótkoterminowy), po id obiektu */
    rentals: (list as BasketItem[]).reduce((result, item) => {
      if (item.type === BASKET_TYPES.rent && item.rentalUpsellFor && (cartId || warehouseId ? item.rentalUpsellFor === (cartId || warehouseId) : true)) {
        result[item.id] = item
      }
      return result
    }, {} as basic.Object<BasketItem>),
    list: (list as BasketItem[]).reduce((result, item) => {
      if (
        item.type === BASKET_TYPES.shop &&
        ((cartId || warehouseId)
          ? item.related?.some((r: basic.Form) => (r.cartId ? r.cartId === cartId : r.id === warehouseId))
          : true)
      ) {
        result[item.id] = item
      }
      return result;
    }, {} as basic.Object<BasketItem>)
  }
}

export default useShopItems